import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import { updateEntityField } from "@/api/endpoints/entity";
import type {
  UpdateEntityFieldRequest,
  UpdateEntityFieldResponse,
} from "@/api/types/entity";

export function useUpdateEntityField(): UseMutationResult<
  UpdateEntityFieldResponse,
  Error,
  UpdateEntityFieldRequest,
  unknown
> {
  return useMutation({
    mutationFn: updateEntityField,
  });
}
